import { PrismaOrganizationApiKeyDto } from 'app/API';

export const sortApiKeysByNewestFirst = (keys: PrismaOrganizationApiKeyDto[]): PrismaOrganizationApiKeyDto[] =>
  [...keys].sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
